import { useState } from "react";
import DashboardLayout from "../../../shared/DashboardLayout";
import Pagination from "../../../shared/Pagination";
import SearchInvoiceForm from "./SearchInvoiceForm";
import SearchFormTable from "../../../shared/SearchFormTable";
import {
  searchInvoicePills,
  searchInvoiceTableColumns,
  searchInvoiceTableRows,
  toggleColumns,
} from "../../../mock/SearchInvoice";

const SearchInvoices = () => {
  const [toggleFilters, setToggleFilters] = useState(true);

  const handleToogleFilters = () => {
    setToggleFilters(!toggleFilters);
  };

  return (
    <DashboardLayout>
      <div className="mb-4 p-0 p-sm-3">
        <div className="section_top d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center my-3">
          <div className="mb-3 mb-md-0">
            <h2 className="my-2 me-3 d-inline-block">
              <span>Search Invoice</span>
            </h2>
            <div className="d-inline-block">
              <button className="btn site_btn text-white my-2 me-2">
                Print
              </button>
              <button
                className="btn btn-primary my-2 me-2"
                onClick={handleToogleFilters}
              >
                Toggle Filters
              </button>
            </div>

            <div className="dropdown d-inline-block">
              <button
                className="btn btn-primary dropdown-toggle"
                type="button"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Toggle Columns
              </button>
              <ul
                className="dropdown-menu p-2"
                aria-labelledby="dropdownMenuButton1"
              >
                <input
                  type="text"
                  name="search"
                  className="form-control px-2 mb-2"
                  id="search"
                  placeholder="Search columns"
                />
                {toggleColumns.map((item, index) => (
                  <li className="dropdown-item" key={index}>
                    {item.name}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="d-flex align-items-center mt-2 mt-md-0">
            <span className="me-2">Items Per Page</span>
            <input
              type="number"
              name="item_number"
              value="20"
              className="form-control w-50"
              disabled
            />
          </div>
        </div>

        <SearchInvoiceForm toggleFilters={toggleFilters} />

        <Pagination />

        <SearchFormTable
          pills={searchInvoicePills}
          tableColumns={searchInvoiceTableColumns}
          tableRows={searchInvoiceTableRows}
        />

        <Pagination />
      </div>
    </DashboardLayout>
  );
};

export default SearchInvoices;
